import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link, Stack, TextField, Typography } from "@mui/material";

type Props = {
  tenantId: string;
  orgName: string;
  onTenantIdChange: (value: string) => void;
  onOrgNameChange: (value: string) => void;
};

export default function TenantIdStep({ tenantId, orgName, onTenantIdChange, onOrgNameChange }: Props) {
  return (
    <Stack data-cy="tenant-id-step" spacing={4}>
      <Typography variant="h3">Enter your Wiz Tenant ID and Tenant Name</Typography>

      <Stack spacing={2}>
        <Typography variant="body1">
          To find your Tenant ID and Tenant Name, go to the{" "}
          <Link
            sx={{
              alignItems: "center",
              display: "inline-flex",
              gap: 0.5,
            }}
            color="primary"
            variant="body1"
            underline="none"
            target="_blank"
            href="https://app.wiz.io/tenant-info/general"
            data-cy="wiz-tenant-info-link"
          >
            Wiz Tenant Info page
            <OpenInNewIcon fontSize="inherit" />
          </Link>{" "}
          and copy the Tenant ID value
        </Typography>
      </Stack>

      <Stack spacing={3}>
        <TextField
          label="Tenant ID"
          fullWidth
          value={tenantId}
          required
          onChange={(event) => {
            onTenantIdChange(event.target.value);
          }}
          placeholder="Enter your Wiz Tenant ID"
          data-cy="tenant-id-input"
        />

        <TextField
          label="Tenant Name (Optional)"
          fullWidth
          value={orgName}
          onChange={(event) => {
            onOrgNameChange(event.target.value);
          }}
          placeholder="Enter your Tenant name"
          helperText="This name will help you identify this Wiz connection in your assets"
          data-cy="tenant-name-input"
        />
      </Stack>
    </Stack>
  );
}
